import { getSearchableFields} from '@sgdocs/client';
import { useQuery } from 'react-query';
import { getToken } from './getToken';
import { throwOnUnauthorized } from './throwOnUnauthorized';

type TechnicalParams = {
    sgmDocsBaseUrl: string;
    token: string | null;
    enableQuery?: boolean;
    component: string;
};
type ApiParams = {
    query?: string;
    workspaceIds?: string[];
    modelIds?: string[];
    page?: string;
    size?: string;
};
export function useQueryGetSearchableFields(
    { query, workspaceIds, modelIds, page, size }: ApiParams,
    { sgmDocsBaseUrl, token, enableQuery, component }: TechnicalParams
) {
    const tokenUsed = getToken(token);
    return useQuery(
        `searchable-fields-query-${query}-workspaces-${workspaceIds}-models-${modelIds}-page-${page}-size-${size}`,
        () =>
            throwOnUnauthorized(
                getSearchableFields({ query: query || '', workspaceIds: workspaceIds || [], modelIds: modelIds || [], page: page || '1', size: size || '200',
                    baseUrl: sgmDocsBaseUrl, authorizationHeader: tokenUsed, component }),
                'Get Searchable Fields'
            ),
        {
            refetchOnWindowFocus: false,
            enabled: Boolean(tokenUsed) && (enableQuery !== undefined ? enableQuery : true)
        }
    );
}
